import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsString } from 'class-validator';
import { BoardPurchaseHighPriorityBatchInterface } from '../interfaces/board-purchase-high-priority-batch.interface';

export class BoardPurchaseHighPriorityBatchDto
  implements BoardPurchaseHighPriorityBatchInterface
{
  @ApiProperty({
    type: () => Boolean,
    title: 'isHighPriority',
  })
  @Expose()
  @IsBoolean()
  isHighPriority!: boolean;

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Bulk IDs',
  })
  @Expose()
  @IsArray()
  @IsString({ each: true })
  ids!: string[];
}
